<script setup lang="ts">
import { KindIcon } from '@taler/ui'
import { computed } from 'vue'
import type { TransactionRow } from '../internal/transaction-row.ts'

type Kind = TransactionRow['kind']

const props = defineProps<{ kind: Kind; label: string }>()

// An entry with no kind gets the quiet sunken surface, never a borrowed kind colour.
const TILE_TONE: Readonly<Record<Exclude<Kind, undefined>, string>> = {
  INCOME: 'bg-[color:color-mix(in_srgb,var(--color-income)_12%,transparent)]',
  EXPENSE: 'bg-[color:color-mix(in_srgb,var(--color-expense)_12%,transparent)]',
  TRANSFER: 'bg-[color:color-mix(in_srgb,var(--color-transfer)_12%,transparent)]',
}
const tone = computed(() =>
  props.kind === undefined ? 'bg-[color:var(--color-surface-sunken)]' : TILE_TONE[props.kind],
)
</script>

<template>
  <span
    class="flex h-8 w-8 shrink-0 items-center justify-center rounded-[var(--radius-control)]"
    :class="tone"
  >
    <KindIcon :kind="kind" :label="label" />
  </span>
</template>
